import Loadable from 'pages/Licenses/Loadable';
import reducer from './modules/licenses.slice';
import saga from 'containers/App/modules/entities/groups/groupEntity.saga'

export default {
	component: Loadable,
	saga,
	reducer
};